import {
    USUARIOS_UPDATE_USER_PROFILE_PICTURE_BEGIN,
    USUARIOS_UPDATE_USER_PROFILE_PICTURE_SUCCESS,
    USUARIOS_UPDATE_USER_PROFILE_PICTURE_FAILURE,
    USUARIOS_UPDATE_USER_PROFILE_PICTURE_DISMISS_ERROR,
    USUARIOS_DELETE_USER_PROFILE_PICTURE_BEGIN,
    USUARIOS_DELETE_USER_PROFILE_PICTURE_SUCCESS,
    USUARIOS_DELETE_USER_PROFILE_PICTURE_FAILURE,
   } from './constants'
   import { COMMON_UPDATE_USER_PICTURE } from '../../common/redux/constants';
   import { REACT_APP_IMG } from '../../../common/config';

   import { BFFAgent } from '../../../common/BFFAgent'
   
   export function updateUserProfilePicture(file) {
     return (dispatch) => { 
       dispatch({
         type: USUARIOS_UPDATE_USER_PROFILE_PICTURE_BEGIN,
       });
       const promise = new Promise((resolve, reject) => {
         const doRequest = BFFAgent.User.uploadProfilePicture(file)
         doRequest.then(
           (res) => {
             if (res.data.success) {
               dispatch({
                 type: USUARIOS_UPDATE_USER_PROFILE_PICTURE_SUCCESS,
                 data: res.data.data,
               });
               dispatch({
                 type: COMMON_UPDATE_USER_PICTURE,
                 data: res.data.data,
               })
               resolve(res);
             } else {
               dispatch({
                 type: USUARIOS_UPDATE_USER_PROFILE_PICTURE_FAILURE,
                 data: res.data,
               });
               reject(res.data.errorMessage);
             }
           },
           (err) => {
             dispatch({
               type: USUARIOS_UPDATE_USER_PROFILE_PICTURE_FAILURE,
               data: { error: err },
             });
             reject(err);
           },
         );
       });
       return promise;
     };
   }

   export function deleteUserProfilePicture(fileName){
    return (dispatch) => { 
      dispatch({
        type: USUARIOS_DELETE_USER_PROFILE_PICTURE_BEGIN,
      });
      const promise = new Promise((resolve, reject) => {
        const doRequest = BFFAgent.User.deleteProfilePicture(fileName)
        doRequest.then(
          (res) => {
            if (res.data.success) {
              dispatch({
                type: USUARIOS_DELETE_USER_PROFILE_PICTURE_SUCCESS,
                data: res,
              });
              dispatch({
                type: COMMON_UPDATE_USER_PICTURE,
                data: {
                  profilePictureUrl: ''
                }
              })
              resolve(res);
            } else {
              dispatch({
                type: USUARIOS_DELETE_USER_PROFILE_PICTURE_FAILURE,
                data: res.data,
              });
              reject(res.data.errorMessage);
            }
          },
          (err) => {
            dispatch({
              type: USUARIOS_DELETE_USER_PROFILE_PICTURE_FAILURE,
              data: { error: err },
            });
            reject(err);
          },
        );
      });
      return promise;
    };
   }
   
   export function dismissUpdateUserPassword() {
     return {
       type: USUARIOS_UPDATE_USER_PROFILE_PICTURE_DISMISS_ERROR,
     };
   }
   
   export function reducer(state, action) {
     switch (action.type) {
       case USUARIOS_UPDATE_USER_PROFILE_PICTURE_BEGIN:
         return {
           ...state,
           updateUserProfilePicturePending: true,
           updateUserProfilePictureError: null,
         };
   
       case USUARIOS_UPDATE_USER_PROFILE_PICTURE_SUCCESS:
         return {
           ...state,
           editUser: {
             ...state.editUser,
             profilePictureUrl: action.data.profilePictureUrl ?
            `${REACT_APP_IMG}/${action.data.profilePictureUrl}` :
            '',
           },
           updateUserProfilePicturePending: false,
           updateUserProfilePictureError: null,
         };
   
       case USUARIOS_UPDATE_USER_PROFILE_PICTURE_FAILURE:
         return {
           ...state,
           updateUserProfilePicturePending: false,
           updateUserProfilePictureError: action.data.errorMessage,
         };
   
       case USUARIOS_UPDATE_USER_PROFILE_PICTURE_DISMISS_ERROR:
         return {
           ...state,
           updateUserProfilePictureError: null,
           updateUserProfilePicturePending: false,
         };

         case USUARIOS_DELETE_USER_PROFILE_PICTURE_BEGIN:
         return {
           ...state,
           deleteUserProfilePicturePending: true,
           deleteUserProfilePictureError: null,
         };
   
       case USUARIOS_DELETE_USER_PROFILE_PICTURE_SUCCESS:
         return {
           ...state,
           editUser: {
            ...state.editUser,
            profilePictureUrl: '',
          },
           deleteUserProfilePicturePending: false,
           deleteUserProfilePictureError: null,
         };
   
       case USUARIOS_DELETE_USER_PROFILE_PICTURE_FAILURE:
         return {
           ...state,
           deleteUserProfilePicturePending: false,
           deleteUserProfilePictureError: action.data.errorMessage,
         };
   
       default:
         return state;
     }
   }
   